import moment from 'moment';

export const PROMOTION = {
    ICON: '🔥',
    TITLE: '',
    SUBTITLE: 'Aprovecha un 20% de descuento todo un año',
    PROMOTIONAL_CODE: 'HOTDAYS',
    URL_UTM: 'https://www.talisis.com/membresias?utm_campaign=HotDays&utm_source=banner',
    countdown: {
        startDate: "2026-05-18 00:00:00",
        endDate: "2026-05-25 00:00:00",
        show: false,
    },
    membership:{
        startDate: "2026-05-25 00:00:00",
        endDate: "2026-06-05 23:59:59",
        show: true,
        title:'Usa el código',
        promotion_code: 'HOTDAYS',
        title_2:'y disfruta 🔥 20% de descuento 🔥 en cualquier membresía con',
        subtitle:'período anual.',
        subtitleColor: 'text-blue-300',
    },
};

export const ACTIVATE_COUNTDOWN = PROMOTION?.countdown?.show &&
    moment().isSameOrAfter(moment(PROMOTION.countdown.startDate, 'YYYY-MM-DD HH:mm:ss')) &&
    moment().isSameOrBefore(moment(PROMOTION.countdown.endDate, 'YYYY-MM-DD HH:mm:ss'))

export const ACTIVATE_MEMBERSHIP = PROMOTION?.membership?.show &&
    moment().isSameOrAfter(moment(PROMOTION.membership.startDate, 'YYYY-MM-DD HH:mm:ss')) &&
    moment().isSameOrBefore(moment(PROMOTION.membership.endDate, 'YYYY-MM-DD HH:mm:ss'))
